import {Box, Skeleton} from '@mui/material';

import {departmentHealthSectionCardSx} from './departmentHealthSectionStyles';
import {EmpionPaper} from '../../../../../components/EmpionPaper/EmpionPaper';

export const DepartmentHealthBenchmarkTableSkeleton = () => {
  return (
    <EmpionPaper sx={departmentHealthSectionCardSx}>
      <Box sx={{display: 'flex', alignItems: 'center', gap: 0.75, mb: 1.5}}>
        <Skeleton variant='circular' width={15} height={15} />
        <Skeleton variant='text' width={170} height={18} />
      </Box>
      <Skeleton variant='text' width='95%' height={14} sx={{mb: 2}} />
      <Skeleton variant='rounded' height={180} sx={{borderRadius: '8px'}} />
    </EmpionPaper>
  );
};
